import { CONFIG } from '../../core/config';
import { ViewModel } from '../view-model';

export class OrgTreeNodeModelRunOutput implements ViewModel {
  public readonly friendlyTypeNameSingular = 'Org Tree Node Model Run Output';
  public readonly apiRoute: string;

  orgTreeNodeModelRunOutputId: string;
  orgTreeNodeModelRunId: string;
  nodeOutputId: string;
  modelNodeId: string;
  value: string;
  displayValue: string;
  displayValueUomId: string;

  public json(): any {
    return this;
  }

  public loadFromJson(data) {
    this.orgTreeNodeModelRunOutputId = data.orgTreeNodeModelRunOutputId;
    this.orgTreeNodeModelRunId = data.orgTreeNodeModelRunId;
    this.nodeOutputId = data.nodeOutputId;
    this.modelNodeId = data.modelNodeId;
    this.value = data.value;
    this.displayValue = data.displayValue;
    this.displayValueUomId = data.displayValueUomId;
  }
}
